import React from "react";
import { Link } from "react-router-dom";
import Header from "../../layouts/AuthLayout/header/header";
import CartSection from "./cart-section";

export default function CartPage() {
  return (
    <>
      {/* Header start  */}
      <Header />
      {/* Header End  */}

      {/* Ec breadcrumb start */}
      <div className="sticky-header-next-sec  ec-breadcrumb section-space-mb">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row ec_breadcrumb_inner">
                <div className="col-md-6 col-sm-12">
                  <h2 className="ec-breadcrumb-title">Cart</h2>
                </div>
                <div className="col-md-6 col-sm-12">
                  {/* ec-breadcrumb-list start */}
                  <ul className="ec-breadcrumb-list">
                    <li className="ec-breadcrumb-item">
                      <a href="index.html">Home</a>
                    </li>
                    <li className="ec-breadcrumb-item active">Cart</li>
                  </ul>
                  {/* ec-breadcrumb-list end */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Ec breadcrumb end */}
      {/* Ec cart page */}
      <CartSection />
    </>
  );
}
